<template>
  <div class="liveMenu" id="liveMenu">
    <div class="title">配信方法について</div>
    <div class="step">
      <div class="step__left">
        <div class="step__left__text">
          <p class="step__left__text__1">STEP1</p>
          <p class="step__left__text__2">配信準備</p>
        </div>
      </div>
      <div class="step__right">
        <span class="step__right__text">配信ツール (OBS) をダウンロードしよう！</span>
        <div class="step__right__control">
          <div class="step__right__control__left">
            <p class="controltext">デスクトップで配信する場合</p>
            <a class="menulink" href="https://obsproject.com/ja/download" target="_blank">
              <b-button class="menulink__button">OBS</b-button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="arrow"><img src="@/assets/image/arrow_down.png"/></div>
    <div class="step">
      <div class="step__left">
        <div class="step__left__text">
          <p class="step__left__text__1">STEP2</p>
          <p class="step__left__text__2">配信予定を登録</p>
        </div>
      </div>
      <div class="step__right">
        <span class="step__right__text">配信を見てもらえるようにアピールしよう！</span>
        <div class="step__right__control">
          <router-link class="menulink" to="/cast/mypage/liveScheduleRegistration">
            <b-button class="menulink__button">配信情報を登録</b-button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="arrow"><img src="@/assets/image/arrow_down.png"/></div>
    <div class="step">
      <div class="step__left">
        <div class="step__left__text">
          <p class="step__left__text__1">STEP3</p>
          <p class="step__left__text__2">ストリームキーを取得</p>
        </div>
      </div>
      <div class="step__right">
        <span class="step__right__text">配信するための設定情報を取得しよう！</span>
        <div class="step__right__control">
          <div class="menulink" @click="$router.push('/cast/mypage/liveSchedule')">
            <b-button class="menulink__button">配信予定管理へ</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveMenu'
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-menu.scss';
.buttons {
  display: block;
}
</style>
